import { Deletable, Identificable } from 'shared/types/commonView';
import { isCurrentVersion, isVersionAvailable, VersionedDocumentation } from './currentVersion';

/** What a version is to its documentation, as the user is told next to its number (PT-7117). */
export enum VersionState {
  current = 'current',
  outdated = 'outdated',
  withdrawn = 'withdrawn',
}

export function isCurrentVersionState(state: VersionState): boolean {
  return state === VersionState.current;
}

export function isOutdatedVersionState(state: VersionState): boolean {
  return state === VersionState.outdated;
}

export function isWithdrawnVersionState(state: VersionState): boolean {
  return state === VersionState.withdrawn;
}

/** A withdrawn version (or one of a withdrawn documentation) is withdrawn first; otherwise current or outdated. */
export function getVersionState<TVersion extends Identificable & Deletable>(
  documentation: VersionedDocumentation<TVersion>,
  version: TVersion
): VersionState {
  if (!isVersionAvailable(documentation, version)) {
    return VersionState.withdrawn;
  }
  return isCurrentVersion(documentation, version) ? VersionState.current : VersionState.outdated;
}

/** The version's number as the user sees it, e.g. `v3`; `undefined` before the backend numbers it or without a version. */
export function formatVersionNumber(number: number | null | undefined): string | undefined {
  return number ? `v${number}` : undefined;
}
